import { Extension } from "@tiptap/core";

// Backspace handler that removes the surrounding parent block when the cursor
// sits at the end of a fully link-covered parent (e.g. a paragraph that
// contains nothing but a single linked phrase). Mirrors the per-editor
// implementation that previously lived in web's PostEditor.
export const LinkBackspaceDelete = Extension.create({
    name: "linkBackspaceDelete",

    addKeyboardShortcuts() {
        return {
            Backspace: ({ editor }) => {
                const { state, commands } = editor;
                const { selection, schema } = state;
                const { $from } = selection;

                const linkMark = $from.marks().find((mark) => mark.type.name === "link");
                if (!linkMark) return false;

                const linkType = schema.marks.link;
                if (!linkType) return false;

                const parent = $from.parent;
                const pos = $from.before();
                // Only react when caret is at the very end of the parent block.
                // `nodeSize - 2` accounts for the parent's open/close tokens.
                if ($from.parentOffset !== parent.nodeSize - 2) return false;

                // Confirm the link mark covers the parent's entire content
                // range. `rangeHasMark` operates on document positions, which
                // is the right space here — unlike `editor.getText()`, which
                // returns a flattened string whose offsets don't align with
                // ProseMirror positions.
                const innerStart = pos + 1;
                const innerEnd = pos + parent.nodeSize - 1;
                if (!state.doc.rangeHasMark(innerStart, innerEnd, linkType)) return false;

                return commands.command(({ tr }) => {
                    tr.delete(pos, pos + parent.nodeSize);
                    return true;
                });
            },
        };
    },
});
